import { render } from "./SongPreview.vue?vue&type=template&id=159811b6&scoped=true"
import script from "./SongPreview.vue?vue&type=script&lang=js"
export * from "./SongPreview.vue?vue&type=script&lang=js"

import "./SongPreview.vue?vue&type=style&index=0&id=159811b6&scoped=true&lang=css"
import "./SongPreview.vue?vue&type=style&index=1&id=159811b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159811b6"]])

export default __exports__